<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-4">
                    <h2>ECNs</h2>
                    </div>
                    <div class="col-lg-8 col-8 text-right bid">
                        <button v-if="(isAdmin || isEditor)" :disabled="!settings.isSendToEcn" @click="suspendAllEcns()" type="button" class="btn btn-warning mr-3"><i class="far fa-minus-square"></i> SUSPEND ALL</button>           
                        <button v-if="(isAdmin || isEditor)" :disabled="!settings.isSendToEcn" @click="reuploadAllEcns()" type="button" class="btn btn-warning mr-3"><i class="far fa-minus-square"></i> REUPLOAD ALL</button>           
                        <button v-if="isAdmin || isSuperAdmin" @click="killOperations()" type="button" class="btn btn-warning mr-3"><i class="far fa-minus-square"></i> KILL SWITCH</button>           
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl ecntbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >ECN</th> 
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >HEARTBEAT</th>                           
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >ACTIVE</th> 
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >ECN ID</th> 
                                <th 
                                    scope="col" 
                                    class="sort"
                                   >DRL ID</th>
                                <th 
                                    scope="col" 
                                    class="sort text-right"
                                    >INCREASE</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >APPLY INCREASE</th>  
                                <!-- <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >SUSPENDED</th>                                           -->
                                <th v-if="(isAdmin || isEditor)"
                                    scope="col" 
                                    class="text-center">Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="ecns.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                            </td>
                            </tr>
                            <tr v-for="ecn in ecns" :key="ecn.id" >
                                <td>
                                    <span class="text-primary">{{ecn.ecnId}}</span><br>
                                    <!-- <span>{{ecn.ecnId}}</span> -->
                                </td>
                                <td> 
                                    <span v-if="ecn.ecnId == 'KBP'" class="text-success">{{IBPHeartBeat ? moment(IBPHeartBeat).format("MM/DD/YYYY, h:mm:ss a") : 'N/A'}}</span>                     
                                    <span v-if="ecn.ecnId == 'TMC'" class="text-success">{{TMCHeartBeat ? moment(TMCHeartBeat).format("MM/DD/YYYY, h:mm:ss a") : 'N/A'}}</span>  
                                    <!-- <span v-if="ecn.ecnId == 'MKTX'" class="text-success">{{MKTXHeartBeat ? moment(MKTXHeartBeat).format("MM/DD/YYYY, h:mm:ss a") : 'N/A'}}</span>   -->
                                    <span v-if="ecn.ecnId == 'MKTX'">MKTX-AXE : </span>
                                    <span v-if="ecn.ecnId == 'MKTX'" class="text-success">{{MKTXHeartBeatAXE ? moment(MKTXHeartBeatAXE).format("MM/DD/YYYY, h:mm:ss a") : 'N/A'}}</span>                                   
                                    <br>
                                    <span v-if="ecn.ecnId == 'MKTX'">MKTX-STP : </span>
                                    <span v-if="ecn.ecnId == 'MKTX'" class="text-success">{{MKTXHeartBeatSTP ? moment(MKTXHeartBeatSTP).format("MM/DD/YYYY, h:mm:ss a") : 'N/A'}}</span>                                   
                                    
                                    <span v-if="ecn.ecnId == 'TWR'">TWR-EXE : </span>
                                    <span v-if="ecn.ecnId == 'TWR'" class="text-success">{{TWREXEHeartBeat ? moment(TWREXEHeartBeat).format("MM/DD/YYYY, h:mm:ss a") : 'N/A'}}</span>                                   
                                    <br>
                                    <span v-if="ecn.ecnId == 'TWR'">TWR-OFF : </span>
                                    <span v-if="ecn.ecnId == 'TWR'" class="text-success">{{TWROFFHeartBeat ? moment(TWROFFHeartBeat).format("MM/DD/YYYY, h:mm:ss a") : 'N/A'}}</span>                                   
                                </td>
                                <td>
                                    <span v-if="ecn.active" class="text-success">ACTIVE</span>                                   
                                    <span v-if="!ecn.active" class="text-error">INACTIVE</span>                                   
                                </td>
                                 <td>
                                    <span>{{ecn.ecnId}}</span>                                   
                                </td>
                                <td>
                                    <span v-if="ecn.ecnId == 'TWR'">TWR-EXE : </span><span>{{ecn.senderCompId}}</span>   
                                    <br>                                
                                    <span v-if="ecn.ecnId == 'TWR'">TWR-OFF : </span><span v-if="ecn.senderCompId2">{{ecn.senderCompId2}}</span>                                   
                                </td>
                                <td class="text-right">
                                    <span>{{ecn.increase}}</span>                                   
                                </td>
                                <td class="text-center">
                                    <span v-if="ecn.applyIncrease" class="border border-success rounded-pill px-3 py-1 text-success">true</span>                                   
                                    <span v-if="!ecn.applyIncrease" class="border border-success rounded-pill px-3 py-1 text-error">false</span>                                   
                                </td>
                                <!-- <td class="text-center">
                                    <span v-if="ecn.suspend" class="border border-success rounded-pill px-3 py-1 text-success">YES</span>                                   
                                    <span v-if="!ecn.suspend" class="border border-success rounded-pill px-3 py-1 text-error">NO</span>                                   
                                </td> -->
                                <td class="text-center" v-if="(isAdmin || isEditor)">
                                    <button @click="openEcnEditModal(ecn)" class="btn ibtn btn-outline-primary" title="Edit"><i class="far fa-edit"></i></button>
                                    <div class="dropdown">
                                        <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                            <button  @click="restartEcn(ecn.ecnId)" class="dropdown-item" type="button">Restart</button>
                                            <!-- <button  @click="startEcn(ecn)" class="dropdown-item" type="button">Start</button> -->
                                            <!-- <button  @click="stopEcn(ecn)" class="dropdown-item" type="button">Stop</button> -->
                                            <button :disabled="!settings.isSendToEcn"  @click="suspendEcn(ecn.ecnId)"  class="dropdown-item" type="button">Suspend</button>
                                            <button :disabled="!settings.isSendToEcn"  @click="reupload(ecn.ecnId)"  class="dropdown-item" type="button">Reupload</button>
                                        </div>
                                    </div>
                                    
                                </td>
                            </tr>
                            </tbody>
                        </table>                      
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <ecnedit 
            v-bind:ecnData="ecnData" 
            v-if="ecnEditModalOpen" 
            @close="closeEcnEditModal()" />
    </div>     
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import ecnedit from "./ImsEcnsEditModal"
export default {
  name: "imsComponent",
  components : {
      ecnedit
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        ecns : [],
        ecnEditModalOpen : false,
        ecnsHeartbeat : null,
        heartBeatShow : false,
        ecnHeartbeatApiCall : false,
        disabledReupload : true,
        isAdmin: false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,
        IBPHeartBeat : null,
        TMCHeartBeat : null,
        TWREXEHeartBeat : null,
        TWROFFHeartBeat : null,
        MKTXHeartBeatAXE: null,
        MKTXHeartBeatSTP : null,
        settings : {isSendToEcn : true},
     
    };
  },
  methods: {
    getEcnHearbeatLiveData () {
		this.ecnHeartbeatApiCall = setInterval(() => {
			this.getEcnsHeartBeat();
		}, 10000)
	},
    openEcnEditModal(ecn){
        this.ecnData = {...ecn};
        this.ecnEditModalOpen = true
    },
    closeEcnEditModal(){
        this.ecnEditModalOpen = false;
        this.getEcns();

    },
    getEcns(){
        this.loading = true;
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/ecn/list",
            auth
        )
        .then(result => {
          this.ecns = result.data;
          let isAllEcnsSuspended = true;
          this.ecns.forEach(ecn => {
            if(!ecn.suspend){
                isAllEcnsSuspended = false;
            }
          });
          this.disabledReupload = !isAllEcnsSuspended;
          this.getEcnsHeartBeat();
          this.loading = false;
        })       
    },
    getEcnsHeartBeat(){
        this.getTWDStatus();
        this.getIBPStatus();  
        this.getTMCStatus();   
        this.getMKTXStatus();
    },
    getMKTXStatus(){
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/ecn/lastheartbeat?ecnType=MKTX",
            auth
        )
        .then(result => {
          this.MKTXHeartBeatAXE = result.data[0].date;
          this.MKTXHeartBeatSTP = result.data[1].date;
        })  
    },
    getTWDStatus(){
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/ecn/lastheartbeat?ecnType=TWD",
            auth
        )
        .then(result => {
          this.TWROFFHeartBeat = result.data[0].date;
          this.TWREXEHeartBeat = result.data[1].date;
        })  
    },
    getIBPStatus(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/ecn/lastheartbeat?ecnType=IBP",
            auth
        )
        .then(result => {
          this.IBPHeartBeat = result.data[0].date;
        })  
    },
    getTMCStatus(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/ecn/lastheartbeat?ecnType=TMC",
            auth
        )
        .then(result => {
          this.TMCHeartBeat = result.data[0].date;
        })  
    },
    suspendAllEcns(){
        var message = "Are you sure you want to suspend All ecns?";
        var postData = {"ecns":["IBP","TMC","TWD","MKTX"],"cognitoSub":authService.getUser().cognitoSub};    
        this.$confirm(message,"Suspend All Ecn","",{confirmButtonText:"Suspend All",cancelButtonText : "No"}).then(() => {
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .post(
                config.baseUrlBidSide +
                    "/offer/suspend-all-offer-to-ecn",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("ECN suspension in progress.","","success");
                this.getEcns();
                })
            })
    },
    suspendEcn(ecn){
        let encName;
        encName = ecn;
        if(ecn == 'TWR'){
            encName = "TWD";
        }
        if(ecn == 'KBP'){
            encName = "IBP";
        }
        var message = "Are you sure you want to suspend this ecn?";
        var postData = {"ecns":[encName],"cognitoSub":authService.getUser().cognitoSub};    

        this.$confirm(message,"Suspend Ecn","",{confirmButtonText:"Suspend",cancelButtonText : "No"}).then(() => {
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .post(
                config.baseUrlBidSide +
                    "/offer/suspend-all-offer-to-ecn",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("ECN suspension in progress.","","success");
                this.getEcns();
                })
        })
    },
    reupload(ecn){
        let encName;
        encName = ecn;
        if(ecn == 'TWR'){
            encName = "TWD";
        }
        if(ecn == 'KBP'){
            encName = "IBP";
        }
        var message = "Are you sure you want to reupload suspended offers?";
        var postData = {"ecns":[encName],"cognitoSub":authService.getUser().cognitoSub};    

        this.$confirm(message,"Reupload Offers","",{confirmButtonText:"Reupload",cancelButtonText : "No"}).then(() => {
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .post(
                config.baseUrlBidSide +
                    "/offer/reupload-suspended-ecn-offers",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("Reupload in progress.","","success");
                this.getEcns();
                })
        })
    },
    reuploadAllEcns(){
        var message = "Are you sure you want to reupload suspended offers?";
        var postData = {"ecns":["IBP","TMC","TWD","MKTX"],"cognitoSub":authService.getUser().cognitoSub};    
        this.$confirm(message,"Reupload Offers","",{confirmButtonText:"Reupload",cancelButtonText : "No"}).then(() => {
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .post(
                config.baseUrlBidSide +
                    "/offer/reupload-suspended-ecn-offers",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("Reupload in progress.","","success");
                this.getEcns();
                })
        })
    },
    restartEcn(ecn){
        var message = "Are you sure you want to restart "+ecn+ "?";
        var postData = {          
            "restartTWD" : ecn == 'TWR' ? true :false,
            "restartTMC" : ecn == 'TMC' ? true :false,
            "restartIBP" : ecn == 'KBP' ? true :false,
            "restartMKTX" : ecn == 'MKTX' ? true :false,
            "cognitoSub" : authService.getUser().cognitoSub,
            "isSuspend"  : true
        };    

        this.$confirm(message,"Restart Ecn","",{confirmButtonText:"Restart",cancelButtonText : "No"}).then(() => {
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .post(
                config.baseUrlBidSide +
                    "/ecn/restart-ecn",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("Restart Successfully.","","success");
                this.getEcns();
                })
        })
    },
    killOperations(){
        var message = "Are you sure you want to suspend all offerings to all the ecns and deactivate the ecns?";
        var postData = {"ecns":["TMC","TWD","IBP"],"cognitoSub":authService.getUser().cognitoSub}  

        this.$confirm(message,"Confirm","",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .post(
                config.baseUrlBidSide +
                    "/offer/kill-ecn",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("Under process.","","success");
                this.getEcns();
                })
        })
    },
    startEcn(){
        var message = "Are you sure you want to start this ecn?";
        this.$confirm(message,"Start Ecn","",{confirmButtonText:"Start",cancelButtonText : "No"}).then(() => {})
    },
    getSettings(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/organization/bid-settings?type=OFFER",
            auth
        )
        .then(result => {
          this.settings = result.data;

        })        
    },
  },
  mounted() {
    this.getEcns();
  },
  beforeDestroy () {
	clearInterval(this.ecnHeartbeatApiCall)
  },
  created () {
	this.getEcnHearbeatLiveData();
    this.getSettings();
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          //console.log(role)
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
        }
         //console.log("curret role",this.isAdmin,this.isTrader,this.isEditor,this.isSuperAdmin);
    });
 }
};
</script>
